var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgValaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 226.2 225.1",
    enableBackground: "new 0 0 226.2 225.1",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0B86C8",
    d: "M113,0.2C51,0.2,0.8,50.4,0.8,112.4c0,62,50.2,112.2,112.2,112.2s112.2-50.2,112.2-112.2 C225.2,50.4,175,0.2,113,0.2z M113,192.7c-44.4,0-80.3-36-80.3-80.3c0-44.4,36-80.3,80.3-80.3s80.3,36,80.3,80.3 C193.3,156.8,157.4,192.7,113,192.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B86C8",
    d: "M113,56.6c-30.8,0-55.8,25-55.8,55.8s25,55.8,55.8,55.8s55.8-25,55.8-55.8S143.8,56.6,113,56.6z M113,133.9 c-11.9,0-21.5-9.6-21.5-21.5s9.6-21.5,21.5-21.5s21.5,9.6,21.5,21.5S124.9,133.9,113,133.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValaLogo);
export default __webpack_public_path__ + "static/media/vala-logo.8d89831ab2438c82f787962488768f8e.svg";
export { ForwardRef as ReactComponent };